module.exports = __webpack_public_path__ + "contacts-cbf4f629/upsell_icon_green-0d5d5c13b6f65d5bf95ec15dbe592bcd.png";